module.exports = __webpack_public_path__ + "img/s2-2.29b23bf7.svg";